/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { Link, useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { formatDate, renderAmount, getTicketStatusDescription } from "../../../../../helpers/reportsHelper";
import { useLocaleContext } from '../../../../../contexts/localeContext';

/* Components */
import UCGrid from "../../../../ucgrid";
import ReportsNoBookings from "../../../../reportsNoBookings"

/* Styles */
import styles from "./styles.js"


const TicketsGrid = (props) => {
  const {gridOptions, setGridOptions, ticketsResponse, onRowClick, handleSort, defaultSort} = props;
  const theme = useTheme();
  const classes = styles({ theme });
  const navigate = useNavigate();
  const globalLocale = useLocaleContext();

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <div className={classes.ticketsGrid}>
      <UCGrid
        gridName="ticketsGrid"
        data={ticketsResponse?.results}
        columns={ticketsResponse?.columns}
        actions={ticketsResponse?.actions}
        handlePageChange={(page) => {
          setGridOptions({
            ...gridOptions,
            page,
          });
          page > 1
            ? navigate(`/app/reports/tickets?page=${page}`)
            : navigate(`/app/reports/tickets`);
        }}
        setSelectedRow={setSelectedRow}
        spinner="ticketsGridSpinner"
        customColumns={{
          baseFare: (row) => <div className={classes.details}>{renderAmount(row?.baseFare)}</div>,
          totalTaxes: (row) => <div className={classes.details}>{renderAmount(row?.totalTaxes)}</div>,
          ancillaryTotal: (row) => <div className={classes.details}>{renderAmount(row?.ancillaryTotal)}</div>,
          totalFare: (row) => <div className={classes.details}>{renderAmount(row?.totalFare)}</div>,
          ticketNumber: (row) => {
            return row.ticketNumber ? String(row.ticketNumber) : '';
          },
          issueDateTime: (row) => (
            <div className={classes.link}>{formatDate(row?.issueDateTime, globalLocale)}</div>
          ),
          bookedDateTime: (row) => (
            <div className={classes.link}>{formatDate(row?.bookedDateTime, globalLocale)}</div>
          ),
          ticketStatus : (row) => {
            return row.ticketStatus ? getTicketStatusDescription(row.ticketStatus) : '-';
          },
        }}
        columnCustomWidth={{
          firstName: '230px !important',
          middleName: '230px !important',
          lastName: '230px !important',
          issueDateTime: '230px !important',
          fareBasis: '230px !important',
          fopCreditCard: '230px !important',
          ticketNumber: '200px !important'
        }}
        noDataComponent={<ReportsNoBookings />}
        showHeader={true}
        persistTableHead={false}
        onRowClick={onRowClick}
        handleSort={handleSort}
        defaultSort={defaultSort}
      />
    </div>
  );
}

export default TicketsGrid;
